export default "__VITE_ASSET__DQhW1lui__"